import { useEffect, useState } from "react";

const DEFAULT_IDLE_EXPAND_MS = 2000;
const DEFAULT_SCROLL_THRESHOLD_PX = 4;

interface IUseScrollCollapseOptions {
  idleExpandMs?: number;
  thresholdPx?: number;
}

// True while the visitor scrolls down (away from the top); turns false again
// on scroll up or once the page has been idle for a moment.
export const useScrollCollapse = ({
  idleExpandMs = DEFAULT_IDLE_EXPAND_MS,
  thresholdPx = DEFAULT_SCROLL_THRESHOLD_PX
}: IUseScrollCollapseOptions = {}): boolean => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    let lastY = window.scrollY;
    let idleTimer: ReturnType<typeof setTimeout> | undefined;

    const handleScroll = () => {
      const delta = window.scrollY - lastY;
      if (Math.abs(delta) < thresholdPx) return;
      lastY = window.scrollY;
      setIsCollapsed(delta > 0 && window.scrollY > 0);
      clearTimeout(idleTimer);
      idleTimer = setTimeout(() => setIsCollapsed(false), idleExpandMs);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(idleTimer);
    };
  }, [idleExpandMs, thresholdPx]);

  return isCollapsed;
};
